// src/config.js
const API_URL = process.env.REACT_APP_API_URL || 'https://7qpkqovgc6jnmmqpnttvzelbtq0chpmc.lambda-url.eu-west-1.on.aws';

export default {
  API_URL,
};
